import BlockedContent from './BlockedContent'

export default BlockedContent
